export const constant = {
	selector: {
		questionContainer: '.js-question-tabs-container',
	},
}
